// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bulk-member-container {
  width: 100%;
  margin: 2em;
  height: 20em;
  overflow: scroll;
}

.bulk-member-container::-webkit-scrollbar {
  width: 9px !important;
  background-color: white !important;
}

.bulk-member-container::-webkit-scrollbar-thumb {
  background-color: rgba(155, 155, 155, 0.5) !important;
  border-radius: 20px !important;
  border: transparent !important;
}

.bulk {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.bulk .form-input > input {
  padding: 6px !important;
}
.bulk .bulk-member-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row !important;
  background-color: #f3f6f9;
  padding: 1em;
  border-radius: 1em;
  margin: 0.5em;
  gap: 1em;
  width: auto !important;
}
.bulk .bulk-member-option-value {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.bulk .bulk-member-option-value input {
  width: 60%;
}
.bulk .bulk-member-delete-button {
  cursor: pointer;
}
.bulk-select {
  width: 100% !important;
}
.bulk-operator {
  display: flex;
  gap: 1em;
  padding-left: 0.5em;
  color: #777776;
  font-size: 0.9em;
}
.bulk-operator-container {
  padding-left: 0.5em;
}
.bulk-operator span:not(:first-child) {
  margin-left: -0.7em;
}
.bulk-operator-feedback {
  color: #777776;
  font-size: 0.8em;
  margin-left: 1em !important;
}
.bulk-operator-selected {
  color: black;
  font-weight: 500;
}
.bulk-title {
  font-size: 1.5em;
  font-weight: bold;
}
.bulk-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.bulk-form {
  display: flex;
  flex-direction: column;
}
.bulk-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
}
.bulk-form-radio-group {
  width: 100%;
  padding: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bulk-form-radio {
  display: flex;
  justify-content: center;
  align-items: center;
}

.form-check {
  margin: 1em;
}

.link-content-container {
  width: 100%;
}

.bulk-step {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.2em;
}

.bulk-step-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 1em;
  padding: 1em;
  gap: 2em;
  border: 1px solid grey;
  border-radius: 1em;
}`, "",{"version":3,"sources":["webpack://./src/components/views/bulk/bulkForm/bulkActionForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAFD;;AAKA;EACC,qBAAA;EACA,kCAAA;AAFD;;AAKA;EACC,qDAAA;EACA,8BAAA;EACA,8BAAA;AAFD;;AAKA;ECpBC,aAAA;EACA,uBDoBc;ECnBd,uBDmBsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,uBAAA;AAAF;AAGC;EC/BA,aAAA;EACA,8BD+Be;EC9Bf,mBD8B8B;EAC7B,8BAAA;EACA,yBE9BK;EF+BL,YAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AACF;AACE;ECzCD,aAAA;EACA,8BDyCgB;ECxChB,mBDwC+B;EAC7B,WAAA;AAGH;AADG;EACC,UAAA;AAGJ;AAEC;EACC,eAAA;AAAF;AAGC;EACC,sBAAA;AADF;AAIC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cEzDU;EF0DV,gBAAA;AAFF;AAIE;EACC,mBAAA;AAFH;AAKE;EACC,mBAAA;AAHH;AAME;EACC,cErES;EFsET,gBAAA;EACA,2BAAA;AAJH;AAOE;EACC,YAAA;EACA,gBAAA;AALH;AASC;EACC,gBAAA;EACA,iBAAA;AAPF;AAUC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBE9FM;AFsFR;AAWC;EACC,aAAA;EACA,sBAAA;AATF;AAWE;ECxGD,aAAA;EACA,6BDwGgB;ECvGhB,uBDuG8B;EAC5B,eAAA;AAPH;AAUE;EACC,WAAA;EACA,YAAA;ECzGF,aAAA;EACA,sBAAA;EACA,uBDwGsB;ECvGtB,mBDuG8B;AAL/B;AAQE;ECnHD,aAAA;EACA,uBDmHgB;EClHhB,mBDkHwB;AAJzB;;AAUA;EACC,WAAA;AAPD;;AAUA;EACC,WAAA;AAPD;;AAUA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAPD;;AAUA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;AAPD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.bulk-member-container {\n\twidth: 100%;\n\tmargin: 2em;\n\theight: 20em;\n\toverflow: scroll;\n}\n\n.bulk-member-container::-webkit-scrollbar {\n\twidth: 9px !important;\n\tbackground-color: #ffff !important;\n}\n\n.bulk-member-container::-webkit-scrollbar-thumb {\n\tbackground-color: rgba(155, 155, 155, 0.5) !important;\n\tborder-radius: 20px !important;\n\tborder: transparent !important;\n}\n\n.bulk {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t.form-input > input{\n\t\tpadding: 6px !important;\n\t}\n\n\t.bulk-member-option {\n\t\t@include flex(space-between, center);\n\t\tflex-direction: row !important;\n\t\tbackground-color: $grey;\n\t\tpadding: 1em;\n\t\tborder-radius: 1em;\n\t\tmargin: .5em;\n\t\tgap: 1em;\n\t\twidth: auto !important;\n\n\t\t&-value {\n\t\t\t@include flex(space-between, center);\n\t\t\twidth: 100%;\n\n\t\t\tinput {\n\t\t\t\twidth: 60%;\n\t\t\t}\n\t\t}\n\t}\n\n\t.bulk-member-delete-button {\n\t\tcursor: pointer;\n\t}\n\t\n\t&-select {\n\t\twidth: 100% !important;\n\t}\n\t\n\t&-operator {\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\tpadding-left: 0.5em;\n\t\tcolor: $dark-grey;\n\t\tfont-size: 0.9em;\n\n\t\t&-container {\n\t\t\tpadding-left: 0.5em;\n\t\t}\n\n\t\tspan:not(:first-child) {\n\t\t\tmargin-left: -0.7em;\n\t\t}\n\n\t\t&-feedback {\n\t\t\tcolor: $dark-grey;\n\t\t\tfont-size: 0.8em;\n\t\t\tmargin-left: 1em !important;\n\t\t}\n\n\t\t&-selected {\n\t\t\tcolor: black;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t}\n\n\t\t&-radio-group {\n\t\t\twidth: 100%;\n\t\t\tpadding: 2em;\n\t\t\t@include flexColumn(center, center);\n\t\t}\n\n\t\t&-radio {\n\t\t\t@include flex(center, center);\n\t\t}\n\n\t}\n}\n\n.form-check {\n\tmargin: 1em;\n}\n\n.link-content-container{\n\twidth: 100%;\n}\n\n.bulk-step {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: .2em;\n}\n\n.bulk-step-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 100%;\n\tmargin: 1em;\n\tpadding: 1em;\n\tgap: 2em;\n\tborder: 1px solid grey;\n\tborder-radius: 1em;\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
